/**
 * AIOL Product Page JS
 * Colour selection: Empire native dropdown (no custom swatches)
 * Description expander: forces accordion open
 */

function expandProductDescriptions() {
  document.querySelectorAll('.product-block--description').forEach(function(block) {
    block.style.maxHeight = '';
    block.style.height = 'auto';
    block.style.overflow = 'visible';
    block.querySelectorAll('[style]').forEach(function(el) {
      if (el.style.maxHeight === '0px' || el.style.maxHeight === '0') {
        el.style.maxHeight = 'none';
        el.style.overflow = 'visible';
      }
    });
    block.querySelectorAll('[aria-expanded="false"]').forEach(function(t) {
      t.setAttribute('aria-expanded', 'true');
    });
    block.querySelectorAll('[aria-hidden="true"]').forEach(function(c) {
      c.setAttribute('aria-hidden', 'false');
    });
  });
  document.querySelectorAll('.accordion__content, [data-accordion-content]').forEach(function(el) {
    if (el.style.maxHeight === '0px' || parseFloat(el.style.maxHeight) < 10) {
      el.style.maxHeight = 'none';
      el.style.overflow = 'visible';
    }
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', function() {
    setTimeout(expandProductDescriptions, 1200);
    setTimeout(expandProductDescriptions, 2500);
  });
} else {
  setTimeout(expandProductDescriptions, 1200);
  setTimeout(expandProductDescriptions, 2500);
}
